import currency from 'currency.js';
import { useState, useEffect, useRef } from 'react';
import PaidSubscriptionOffer from '../PaidSubscriptionOffer';
import { connect, useDispatch } from 'react-redux';
import { fetchPosts, setAlert, setCreditCardForm, setProcessingFollow } from '../../../redux/actions';
import PSignupModal from '../PSignupModal';
import { getFirstSegment, inFreeTiers, isLogin, notExpired, postTypeNeedsSubscription } from '../../utils/helper';
import PThankYou from '../PThankYou';
import { FOLLOW_STATUS, POST_TYPE } from '../../utils/constants';
import moment from 'moment';
import { setPostThankyou } from '../../../redux/actions/post';

const currencyOption = {
    precision: 2
};

const UpgradeToUnlock = ({
    post,
    buttonStyle = {},
    buttonClassname = null,

    posts,
    selectedPostGallery,
}) => {
    const type = isLogin()
        ? 'follow'
        : 'signup';

    const dispatch = useDispatch();

    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    const [showPaid, setShowPaid] = useState(false);
    const [busy, setBusy] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [followStatus, setFollowStatus] = useState(false);
    const [otherUserData, setOtherUserData] = useState(null);

    useEffect(() => {
        if (showPaid) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [showPaid]);

    useEffect(() => {
        if (followStatus) {
            dispatch(setPostThankyou({
                show: true,
                pu: otherUserData,
                upgrade: true
            }));
            // selectedPostGallery is used in media gallery modal
            if (!selectedPostGallery || Object.keys(selectedPostGallery).length == 0) {
                const requireSubscriptionPostIds = posts
                    .filter(p => postTypeNeedsSubscription(p.post_type))
                    .map(p => p.id);
                dispatch(fetchPosts({
                    post_ids: requireSubscriptionPostIds,
                    user: post.user.login,
                    source
                }));
            }
        }
    }, [followStatus]);

    useEffect(() => {
        setOtherUserData(post.user);
    }, [post]);

    const handleClose = () => {
        setShowPaid(false);
    };

    const handlePaymentShow = () => {
        dispatch(setCreditCardForm({
            show: true,
            prefilled: true,
            closeOnly: true,
            intent: 'follow',
            username: otherUserData.login
        }));
    };

    const handleFollow = async (e) => {
        e.preventDefault();

        setIsChecking(true);
        await axios.get('/api/transactions/check')
            .then(response => {
                if (response.data.check || (promoUrl && promoUrl.hasOwnProperty('is_free_link') && promoUrl.is_free_link)) {
                    processPayment();
                } else {
                    handlePaymentShow();
                    setIsChecking(false);
                }
            })
            .catch(error => {
                console.error({ error });
                setIsChecking(false);
                if (error.response.status === 402) {
                    handleClose();
                    handlePaymentShow();
                } else {
                    dispatch(setAlert({
                        type: 'error',
                        show: true,
                        body: 'Unable to follow user'
                    }));
                }
            });
    };

    const processPayment = async () => {
        setBusy(true);
        dispatch(setProcessingFollow(true));

        let payload = {
            user_id: otherUserData.id,
            free_subscription: false,
            by_subscription: true
        };

        await axios
            .post('/api/transactions', payload)
            .then(response => {
                setBusy(false);
                dispatch(setProcessingFollow(false));

                if (!response.data.success && response.data.url) {
                    window.location = response.data.url;
                    return;
                }

                // handler for free trial links
                if (!response.data.status && !response.data.url && response.data.message) {
                    dispatch(setAlert({
                        show: true,
                        type: 'error',
                        body: response.data.message,
                        onClose: () => window.location.reload()
                    }));
                    localStorage.removeItem('promo_url');
                    return;
                }

                window.dispatchEvent(new Event('profile/getCreatorInformation'));
                setShowPaid(false);
                // setShowThankYou(true);
            })
            .catch(error => {
                console.error({ error });
                setBusy(false);
                dispatch(setProcessingFollow(false));
            });
    };

    const getUserInformation = () => {
        window.dispatchEvent(new Event('profile/getCreatorInformation'));
    };

    const handleSubscribe = () => {
        setShowPaid(true);
    };

    const RenderButtonLabel = () => {
        if (post && Object.keys(post).length > 0) {
            let postPrice = post.price;
            if (post.promo_price > 0) {
                let expiryDate = moment.utc(post.expire_at).local();

                if (moment().isBefore(expiryDate)) {
                    postPrice = post.promo_price;
                }
            }

            if (inFreeTiers(post.tier) && !post.unlocked && postTypeNeedsSubscription(post.post_type)) {
                if (post.post_type == POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION && postPrice > 0) {
                    return `Subscription Required + ${currency(postPrice).format(currencyOption)} PPV`;
                }

                return 'Subscription Required';
            }
        }

        return null;
    };

    return <>
        <div className='post__purchase'>
            <button
                type='button'
                className='btn btn-follow theme-btn theme-btn-bordered text-uppercase btn-post-ppv'
                onClick={handleSubscribe}
            >
                <RenderButtonLabel />
            </button>
        </div>

        {
            showPaid
                ? <PSignupModal
                    showModal={showPaid}
                    setShowModal={setShowPaid}
                    user={otherUserData}
                    type={type}
                    setSignupFormStatus={setSignupFormStatus}
                    setFollowStatus={setFollowStatus}
                    getUserInformation={getUserInformation}
                />
                : null
        }

        {/* {
            showThankYou
                ? <PThankYou
                    show={showThankYou}
                    pu={otherUserData}
                    setShow={setShowThankYou}
                    isUpgrade={true}
                />
                : null
        } */}
    </>;
};

const mapStateToProps = state => ({
    posts: state.post.posts,
    selectedPostGallery: state.post.selectedPostGallery,
});

export default connect(mapStateToProps)(UpgradeToUnlock);